var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.495 18.35H5.447a.947.947 0 01-.947-.947V5.447c0-.523.424-.947.947-.947h13.048c.523 0 .947.424.947.947v11.956a.947.947 0 01-.947.947z",
    stroke: "#666",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22 15.903l7.822-7.823M8.22 19.032v.991",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M8.22 18.372v.991"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.043 19.032v.991"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M16.043 18.372v.991"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M8.2 6.75l8 9M8.2 15.75l8-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.028 8.921a4 4 0 11-5.655 5.658 4 4 0 015.655-5.658z",
    stroke: "#666",
    fill: "#666",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.614 10.335a2 2 0 11-2.828 2.83 2 2 0 012.828-2.83z",
    stroke: "#FFF",
    fill: "#666"
  })))));
}
export default SvgSafe;